/**
 * 예약 닉네임 (사용 불가)
 * - 공식 운영 관련 단어 + 시스템 봇 관련
 * - 대소문자 구분 없이 체크
 */
export const RESERVED_NICKNAMES = [
  '관리자',
  '마스터',
  '운영자',
  '시세공간',
  '관리',
  'admin',
  'master',
  'operator',
  '시세공간봇',
  'sisegonggan',
  '공지',
  '운영팀',
  'moderator',
  'staff',
  '관리팀',
  '지원팀',
];

export function isReservedNickname(nickname: string): boolean {
  const n = nickname.trim().toLowerCase();
  return RESERVED_NICKNAMES.some((r) => r.toLowerCase() === n);
}
